import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class MainJob_se {
    constructor() {
        this.entity = 'mainJob';
    }

    delete(id) {
        return Api.delete(this.entity,id)}


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }

    getPage(page_,size_) {
        return Api. getPage(this.entity,page_,size_)
    }

    save(model) {
        return Api.save(this.entity,model)
    }

    search(value){
        let search=value;
        let formData=new FormData();
        formData.append("search",search,)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })
    }
    advancedSearch(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/advancedSearch',
            headers: {'Content-Type': 'application/json'},
        })
    }

    getSubGroupList(id){
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/getSubGroup/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }




}
export default new MainJob_se();
